'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('../style-222d2b0f.js');
var panelStyles = require('../panel-styles-275a918b.js');
var span = require('../typography/span.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  font-family: Source Sans Pro, sans-serif;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  position: relative;\n  padding: ", ";\n  margin-top: 10px;\n  font-size: ", ";\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n  border-radius: 8px;\n  width: ", ";\n  @media (max-width: 991px) {\n    width: 100%;\n  }\n  ", ";\n"], ["\n  font-family: Source Sans Pro, sans-serif;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  position: relative;\n  padding: ", ";\n  margin-top: 10px;\n  font-size: ", ";\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.43;\n  letter-spacing: normal;\n  border-radius: 8px;\n  width: ", ";\n  @media (max-width: 991px) {\n    width: 100%;\n  }\n  ", ";\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  font-size: ", ";\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  ", "\n  ", "\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n"], ["\n  cursor: pointer;\n  position: absolute;\n  right: 10px;\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"]);

var ErrorAlertPanel = styled__default(panelStyles.Panel)(_templateObject, function (props) {
  return props.padding ? props.padding : "10px 10px";
}, function (props) {
  return props.fontSize ? props.fontSize : "14px";
}, function (props) {
  return props.width ? props.width : "100%";
}, function (props) {
  return props.margin && "margin: " + props.margin;
});

var I = styled__default.i(_templateObject2, function (props) {
  return props.size ? props.size : "20px";
}, function (props) {
  return props.color && "color: " + props.color + ";";
}, function (props) {
  return props.margin && "margin: " + props.margin + ";";
});

var CloseButtonWrapper = styled__default.span(_templateObject3);

var ErrorMessageWrapper = styled__default.div(_templateObject4);

var ErrorAlert = function ErrorAlert(_ref) {
  var errorMessage = _ref.errorMessage,
      secondaryMessage = _ref.secondaryMessage,
      rentspreeContact = _ref.rentspreeContact,
      onClose = _ref.onClose,
      rest = _babelHelpers.objectWithoutProperties(_ref, ["errorMessage", "secondaryMessage", "rentspreeContact", "onClose"]);
  return React__default.createElement(
    ErrorAlertPanel,
    _babelHelpers._extends({}, rest, { error: true }),
    React__default.createElement(I, { size: "20px", className: "fas fa-exclamation-circle" }),
    React__default.createElement(
      ErrorMessageWrapper,
      null,
      React__default.createElement(
        span,
        { mr: "32", ml: "10", weight: 600 },
        errorMessage
      ),
      React__default.createElement(
        span,
        { mr: "32", ml: "10", weight: 400 },
        secondaryMessage
      )
    ),
    React__default.createElement(
      CloseButtonWrapper,
      { id: "closeAlertBtn", onClick: onClose },
      React__default.createElement(I, { size: "20px", className: "fal fa-times" })
    )
  );
};

ErrorAlert.propTypes = {
  /** Error message that will show in the alert */
  errorMessage: PropTypes$1.string.isRequired,
  /** Secondary message that will show in the alert */
  secondaryMessage: PropTypes$1.string,
  /** Function that will get call when the user click at close button */
  onClose: PropTypes$1.func,
  /** size of the error message */
  fontSize: PropTypes$1.string,
  /** width of alert panel */
  width: PropTypes$1.string,
  /** margin of alert panel */
  margin: PropTypes$1.string,
  /** padding of alert panel */
  padding: PropTypes$1.string
};

ErrorAlert.defaultProps = {
  fontSize: "14px",
  width: "100%",
  margin: "0px",
  padding: "10px 10px"
};
ErrorAlert.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ErrorAlert",
  "props": {
    "fontSize": {
      "defaultValue": {
        "value": "\"14px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "size of the error message"
    },
    "width": {
      "defaultValue": {
        "value": "\"100%\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "width of alert panel"
    },
    "margin": {
      "defaultValue": {
        "value": "\"0px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "margin of alert panel"
    },
    "padding": {
      "defaultValue": {
        "value": "\"10px 10px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "padding of alert panel"
    },
    "errorMessage": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Error message that will show in the alert"
    },
    "secondaryMessage": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Secondary message that will show in the alert"
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function that will get call when the user click at close button"
    }
  }
};

module.exports = ErrorAlert;
//# sourceMappingURL=error-alert.js.map
